import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./app/store";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

import { addScriptDefault } from "meta-pixel";

const fbq = addScriptDefault();
const PIXEL_ID = process.env.REACT_APP_FACEBOOK_PIXEL_ID as string | undefined;
if (PIXEL_ID) {
  fbq("set", "autoConfig", PIXEL_ID, true);
  fbq("init", PIXEL_ID);
  fbq("track", "PageView");
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
